import React from 'react';

import { Box, Button, Theme, Typography, useTheme } from '@material-ui/core';
import { FallbackProps } from 'react-error-boundary';

import config, { ENVIRONMENTS } from '../api/config';

const reloadPage = () => window.location.reload();

export const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const theme = useTheme<Theme>();
  const showDevDetails = config.environment !== ENVIRONMENTS.PROD;

  return (
    <Box
      role="alert"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      padding={3}
      bgcolor={theme.palette.background.default}>
      <Box
        maxWidth={520}
        width="100%"
        padding={4}
        bgcolor={theme.palette.background.paper}
        borderRadius={16}
        boxShadow={1}>
        <Typography variant="h5" style={{ fontWeight: 700, marginBottom: theme.spacing(1) }}>
          Something went wrong
        </Typography>
        <Typography variant="body1" color="textSecondary" style={{ marginBottom: theme.spacing(3) }}>
          The page hit an unexpected error. Reload to try again — if it keeps happening, let support
          know.
        </Typography>

        <Box display="flex" gridGap={12} flexWrap="wrap">
          <Button size="large" variant="contained" color="primary" onClick={reloadPage}>
            Reload page
          </Button>
          {resetErrorBoundary && (
            <Button size="large" variant="outlined" color="primary" onClick={resetErrorBoundary}>
              Try again
            </Button>
          )}
        </Box>

        <Box marginTop={3}>
          <details>
            <summary
              style={{
                cursor: 'pointer',
                color: theme.palette.text.secondary,
                fontSize: 13,
              }}>
              Technical details (for support)
            </summary>
            <Box
              marginTop={1}
              padding={2}
              bgcolor={theme.palette.background.default}
              borderRadius={8}>
              <Typography
                variant="caption"
                component="pre"
                style={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  color: theme.palette.error.main,
                  margin: 0,
                  fontFamily: 'monospace',
                }}>
                {error.message}
              </Typography>
              {showDevDetails && error.stack && (
                <Typography
                  variant="caption"
                  component="pre"
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    color: theme.palette.text.secondary,
                    marginTop: 8,
                    fontFamily: 'monospace',
                  }}>
                  {error.stack}
                </Typography>
              )}
            </Box>
          </details>
        </Box>
      </Box>
    </Box>
  );
};
